import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { useSelector } from 'react-redux';
import {
  selectAttributeInfo,
  selectDateRange,
} from '../../../store/options/options.selector';
import { selectTrend } from '../../../store/data/data.selector';

import MarkdownToJsx from '../../markdown-to-jsx/markdown-to-jsx.component';


export default function HistoricalText({ place }) {
  const attributeInfo = useSelector(selectAttributeInfo);
  const trend = useSelector(selectTrend);
  const dateRange = useSelector(selectDateRange);

  let incOrDec = '';
  if (trend > 0) {
    incOrDec = 'increasing by ';
  } else if (trend < 0) {
    incOrDec = 'decreasing by ';
  }

  const text = `In ${place}, data on past ${
    attributeInfo.text
  } show a trend of ${incOrDec}${Math.abs(trend).toFixed(2)}${
    attributeInfo.units
  } per decade between ${dateRange.start} and ${dateRange.end}.`;

  const mdPath = [process.env.PUBLIC_URL, 'markdown', 'state_detail_historical_source.md'].join('/');

  return (
    <>
      <Typography>{text}</Typography>
      
      <MarkdownToJsx path={mdPath} />
    </>
  );
}

HistoricalText.propTypes = {
  place: PropTypes.string,
};
